import _ud7H250ijktn6LpvZuYI from '../dictionary/common.json' with { type: 'json' };
import _e0JwbowOUJSp8QFnLDbi from '../dictionary/cookies.json' with { type: 'json' };
import _8WLLAZBg3fRE0Y5R7l8n from '../dictionary/errors.json' with { type: 'json' };
import _cspiFyWI79Is4dnYT3qj from '../dictionary/footer.json' with { type: 'json' };
import _KHT8TydGkFLlYsT9Yi88 from '../dictionary/header.json' with { type: 'json' };
import _LoxV0bjcxIUzNk5HZDSK from '../dictionary/landing.json' with { type: 'json' };
import _vxbmDEYZtssVq7kKFPx6 from '../dictionary/privacy.json' with { type: 'json' };

const dictionaries = {
  "common": _ud7H250ijktn6LpvZuYI,
  "cookies": _e0JwbowOUJSp8QFnLDbi,
  "errors": _8WLLAZBg3fRE0Y5R7l8n,
  "footer": _cspiFyWI79Is4dnYT3qj,
  "header": _KHT8TydGkFLlYsT9Yi88,
  "landing": _LoxV0bjcxIUzNk5HZDSK,
  "privacy": _vxbmDEYZtssVq7kKFPx6
};
const getDictionaries = () => dictionaries;

export { getDictionaries };
export default dictionaries;
